var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"div-erro"},[_c('div',{staticClass:"container box-msg"},[_c('i',[_c('font-awesome-icon',{attrs:{"icon":_vm.icon}})],1),_c('p',{key:_vm.mensagem,domProps:{"innerHTML":_vm._s(_vm.mensagem)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }